import React, { Component } from "react";
import { Link } from "react-router-dom";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faClipboard,
  faCoffee,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileExcel,
  faFileInvoice,
  faFileText,
  faHistory,
  faHome,
  faIdCard,
  faMapMarkerAlt,
  faMobileAlt,
  faPen,
  faPhone,
  faPrint,
  faRefresh,
  faSave,
  faSearch,
  faTrash,
  faUser,
  faUserPlus,
  faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { StaticDialog, useDialog } from "react-st-modal";
import InputMask from "react-input-mask";

import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";
import withLocation from "../../comps/withLocation";

class HistoryLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      data: [],
      dados: [],
      renew: [],
    };
  }

  componentDidMount() {
    document.title = "Histórico de Locação";

    fetch(`${apiUrl}/history-location/${this.props.params.token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    }).then((response) => {
      if (response.status == 510) {
        localStorage.clear();
        window.location.href = "/";
        return;
      }

      response.json().then((data) => {
        this.setState({
          data: data,
          renew: data.products,
          loader: false,
        });
      });
    });
  }
  formatarMoeda = (valor) => {
    // Remove caracteres que não sejam números
    const apenasNumeros = valor.replace(/\D/g, "");
    // Converte para número e formata em BRL
    const valorFormatado = (Number(apenasNumeros) / 100).toLocaleString(
      "pt-BR",
      {
        style: "currency",
        currency: "BRL",
      }
    );
    return valorFormatado;
  };
  formatarDataBr(dataString) {
    const data = new Date(dataString);

    if (isNaN(data.getTime())) {
      return "---";
    }

    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");

    return `${dia}/${mes}/${ano} às ${horas}:${minutos}`;
  }

  handleChange = (event) => {
    const { id, value } = event.target;

    // Atualizando o estado dentro do objeto `dados`
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados, // Mantém os outros campos do objeto `dados`
        [id]: value, // Atualiza apenas o campo correspondente
      },
    }));
  };
  formatDate(dateString) {
    var e = dateString.split("-");
    var dateString = e[2] + "/" + e[1] + "/" + e[0];
    return dateString;
  }

  endDay() {
    var billing = {
      1: "daily", // 1 dia
      2: "weekly", // 7 dias
      3: "biweekly", // 15 dias
      4: "monthly", // 1 mês (30 dias fixos)
      5: "yearly", // 1 ano
    };

    if (
      !this.state.dados ||
      !this.state.dados.faturamento ||
      !this.state.dados.period
    ) {
      return "Data inválida";
    }

    const faturamento = billing[this.state.dados.faturamento];
    const period = this.state.dados.period || 0;

    let date = new Date(this.state.data.end_day);

    switch (faturamento) {
      case "daily":
        date.setDate(date.getDate() + period);
        break;
      case "weekly":
        date.setDate(date.getDate() + period * 7);
        break;
      case "biweekly":
        date.setDate(date.getDate() + period * 15);
        break;
      case "monthly":
        date.setDate(date.getDate() + period * 30); // Sempre adiciona 30 dias
        break;
      case "yearly":
        date.setFullYear(date.getFullYear() + period);
        break;
      default:
        return "Faturamento inválido";
    }

    // Construção manual do formato 'YYYY-MM-DD HH:mm'
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  getCurrentDateTime() {
    const agora = new Date();

    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, "0");
    const dia = String(agora.getDate()).padStart(2, "0");
    const hora = String(agora.getHours()).padStart(2, "0");
    const minuto = String(agora.getMinutes()).padStart(2, "0");

    return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
  }
  render() {
    if (this.state.loader) {
      return (
        <div class="area-loader">
          <div class="loader"></div>
        </div>
      );
    }
    var product = this.state.data.products;
    var invoicingType = {
      1: "Diária",
      2: "Semanal",
      3: "Quizenal",
      4: "Mensal",
      5: "Anual",
    };
    var billing = {
      1: "day_price",
      2: "weekly_price",
      3: "biweekly_price",
      4: "monthly_price",
      5: "annual_price",
    };
    var type_billing = {
      day_price: "Diária",
      weekly_price: "Semanal",
      biweekly_price: "Quizenal",
      monthly_price: "Mensal",
      annual_price: "Anual",
    };
    var endDay = this.endDay();
    return (
      <>
        <div class="content">
          <div class="card">
            <div class="card-header d-flex align-items-center justify-content-between">
              <strong>
                Histórico de Locação de:{" "}
                {this.state.data[this.state.data.length - 1].client_name}
              </strong>
              <Link
                class="btn btn-primary"
                to={`/lease/contract/${this.props.params.token}`}
                target="_blank"
              >
                <FontAwesomeIcon icon={faFileAlt} /> Contrato
              </Link>
            </div>
            <div class="card-body">
              <table className="table table-striped table-bordered arvore-l mt-2">
                <thead className="thead-dark">
                  <tr>
                    <th>Tipo</th>
                    <th>Valor</th>
                    <th>Data Inicial</th>
                    <th>Data Final</th>
                    <th>Data de Devolução</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.map((item) => (
                    <tr key={item.id}>
                      <td>{item.tdo == 1 ? "Locação" : "Renovação"}</td>
                      <td>
                        {item.location_value.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                      <td>{this.formatarDataBr(item.start_day)}</td>
                      <td>{this.formatarDataBr(item.end_day)}</td>
                      <td>
                        {item.return_day
                          ? this.formatarDataBr(item.return_day)
                          : "---"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withLocation(HistoryLocation);
